'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _actions = require('../Filters/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterUrlWatcher = function (_React$Component) {
  (0, _inherits3.default)(FilterUrlWatcher, _React$Component);

  function FilterUrlWatcher() {
    (0, _classCallCheck3.default)(this, FilterUrlWatcher);
    return (0, _possibleConstructorReturn3.default)(this, (FilterUrlWatcher.__proto__ || (0, _getPrototypeOf2.default)(FilterUrlWatcher)).apply(this, arguments));
  }

  (0, _createClass3.default)(FilterUrlWatcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleUrl();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleUrl();
    }
  }, {
    key: 'handleUrl',
    value: function handleUrl() {
      var _props = this.props,
          match = _props.match,
          filters = _props.filters;
      var store = this.context.store;


      var appliedFilters = (0, _keys2.default)(filters || {});

      var _ref = _bdcoreNamedRoutes2.default.getRouteByPath(match.path) || {},
          routeFilters = _ref.filters,
          filtersRetain = _ref.filtersRetain,
          filtersRemove = _ref.filtersRemove;

      if (this.previousRoute !== match.path) {
        if (routeFilters) {
          (0, _keys2.default)(routeFilters).forEach(function (filter) {
            store.dispatch((0, _actions.setFilter)(filter, routeFilters[filter]));
          });
        }

        if (Array.isArray(filtersRetain)) {
          _lodash.without.apply(undefined, [appliedFilters].concat((0, _toConsumableArray3.default)(filtersRetain))).forEach(function (filter) {
            store.dispatch((0, _actions.setFilter)(filter, null));
          });
        }

        if (Array.isArray(filtersRemove)) {
          filtersRemove.forEach(function (filter) {
            store.dispatch((0, _actions.setFilter)(filter, null));
          });
        }

        this.previousRoute = match.path;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return FilterUrlWatcher;
}(_react2.default.Component);

FilterUrlWatcher.propTypes = {
  match: _propTypes2.default.object.isRequired,
  filters: _propTypes2.default.object.isRequired
};

FilterUrlWatcher.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var _ref2$cloudData = _ref2.cloudData;
  _ref2$cloudData = _ref2$cloudData === undefined ? {} : _ref2$cloudData;
  var builder = _ref2$cloudData.builder,
      filters = _ref2.filters;
  return {
    isLoaded: (0, _keys2.default)(builder).reduce(function (r, b) {
      return builder[b].isFetching || r;
    }, false),
    filters: filters
  };
})(FilterUrlWatcher);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/FilterUrlWatcher.js
// module id = 947
// module chunks = 0